import { FunctionComponent } from 'react';
import { paletteHelper, spacingHelper, Text, typographyHelper } from '@property.com.au/ui-kit';
import styled from 'styled-components';
import { MarketInsightsAdditionalDetail } from '../../types';

const AdditionalDetailsContainer = styled.div`
  margin-top: ${spacingHelper('large')};
  display: flex;
  gap: ${spacingHelper('large')};
  flex-wrap: wrap;
`;

const AdditionalDetailContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacingHelper('extraSmall')};
`;

const DetailTitle = styled(Text)`
  ${typographyHelper('overline')};
  color: ${paletteHelper('textSecondary')};
`;

interface AdditionalDetailsProps {
  additionalDetails: MarketInsightsAdditionalDetail[];
}

export const AdditionalDetails: FunctionComponent<AdditionalDetailsProps> = ({
  additionalDetails,
}) => {
  return (
    <AdditionalDetailsContainer data-testid={'additional-details'}>
      {additionalDetails.map((ad) => {
        return (
          <AdditionalDetailContainer key={`additional-detail:${ad.title}${ad.displayValue}`}>
            <DetailTitle>{ad.title}</DetailTitle>
            <Text variant={'subtitle01'}>{ad.displayValue}</Text>
          </AdditionalDetailContainer>
        );
      })}
    </AdditionalDetailsContainer>
  );
};
